module.exports = __webpack_public_path__ + "static/1-db9c312ebb8821502df41683ed68f310.jpeg";